import React from "react";
import AsideBlock from "../../../components/AsideBlock";
import { Table } from "antd";
import useRequest from "../../../../../../utils/useRequest";
import { getIpRange } from "../../../../../../service/exam";

interface AsideIpProps {
    examId: string;
}

export function AsideIp({ examId }: AsideIpProps) {
    const [data] = useRequest(() => getIpRange(examId), {}, [examId]);

    const columns = [
        { title: "机房", dataIndex: "name", width: "50%" },
        {
            title: "IP池范围",
            dataIndex: "ipRange",
            width: "50%",
            render: (text: string) => <div style={{ fontSize: 12 }}>{text}</div>
        }
    ];

    return (
        <AsideBlock title="机房信息">
            <Table
                columns={columns}
                dataSource={data || []}
                pagination={false}
                bordered
            />
        </AsideBlock>
    );
}
